const prefix = 'posfacil';

export const localStorageKeys = {
  DYNAMIC_SIDEBAR_DATA: `${prefix}-dynamic-sidebar`,
};
